<template>
  <div>
    <w-table ref="wMyTable" :columns="columns" :table-data="data" :isPagination="true" :page="page"       
    :openTableHeadNote="false"
      @pageChange="handlePagePagination" :isShowRowSelection="isShowRowSelection" @rowSelection="rowSelection">
      <div slot="projectClassification" slot-scope="{text,record}">
        <div class="status-tag-container">
          <el-tag type="success">{{ TypeOption.find(item => item.label === text).name }}</el-tag>
        </div>
      </div>
      <div slot="numberOfSamples" slot-scope="{text,record}">
        <div class="center" v-if="record.experimentalProcessItems && record.experimentalProcessItems.length>0">
          <div v-for="(data,index) in record.experimentalProcessItems">
            <div>
              {{ data.experimentName + ':' + data.numberOfExperiment }}
            </div>
          </div>
        </div>
        <div class="status-tag-container" v-else>
          <span v-for="(data,index) in record.projectSampleDataList?record.projectSampleDataList:[]">{{ (index !==
            0?'/':'') + data.numberOfSamples }}</span>
        </div>
      </div>
      <div slot="sizeOfSampleData" slot-scope="{text,record,index}">
        <div class="status-tag-container">
          <ex-fold-table
            :scope="{ time: time.filter(item => Object.keys(record.projectSampleDataList[0]['sizeOfSampleData']).includes(item.time)), record: record.projectSampleDataList, dataIndex: 'sizeOfSampleData', index, dataAmountUnit: record['dataAmountUnit']}"></ex-fold-table>
        </div>
      </div>
      <div slot="projectAmount" slot-scope="{text,record,index}">
        <div class="center" v-if="record.experimentalProcessItems && record.experimentalProcessItems.length>0">
          <div v-for="(data,index) in record.experimentalProcessItems">
            <div>
              {{ data.experimentName + ':' + data.experimentAmount }}
            </div>
          </div>
        </div>
        <div class="status-tag-container" v-else>
          <div class="status-tag-container" v-if="text">{{text}}</div>
          <div class="status-tag-container" v-else>{{'NA'}}</div>
        </div>
      </div>
      <div slot="projectNewAmount" slot-scope="{text,record,index}">
        <div class="center" v-if="record.settledExperimentalProcessItems && record.settledExperimentalProcessItems.length>0">
          <div v-for="(data,idx) in record.settledExperimentalProcessItems" :key="idx">
            <div :class="{ 'amount-changed': isExperimentAmountChanged(record, data) }">
              {{ data.experimentName + ':' + data.experimentAmount }}
            </div>
          </div>
        </div>
        <span v-else :class="{ 'amount-changed': isProjectAmountChanged(record) }" style="font-weight: bold;">{{ text }}</span>
      </div>
      <div slot="collectingFlag" slot-scope="{text,record,index}">
        <div v-if="record.projectMainTypeId" class="status-tag-container">
          <el-tag type="success" v-if="text">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </div>
        <div v-else class="status-tag-container">
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="qualityFlag" slot-scope="{text,record,index}">
        <div v-if="record.projectMainTypeId" class="status-tag-container">
          <el-tag type="success" v-if="text">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </div>
        <div v-else class="status-tag-container">
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="sampleNum" slot-scope="{text,record,index}">
        <div v-if="text" class="status-tag-container">{{text}}</div>
        <div v-else class="status-tag-container">{{'NA'}}</div>
      </div>
      <div slot="projectStatus" slot-scope="{text,record,index}">
        <div v-if="text === 'NORMAL'" class="status-tag-container"><el-tag type="success">正常</el-tag></div>
        <div v-else-if="text === 'TERMINATION'" class="status-tag-container"><el-tag type="danger">实验终止</el-tag></div>
        <div v-else-if="text === 'APPLYING'" class="status-tag-container"><el-tag type="warning">申请终止</el-tag></div>
        <div v-else class="status-tag-container"><el-tag type="info">NA</el-tag></div>
      </div>
      <div slot="sequencingPlatform" slot-scope="{text,record,index}">
        <div v-if="record.sequencingPlatform || record.thirdSequencingPlatform" class="status-tag-container"
          style="flex-direction: column; align-items: flex-start;">
          <span v-if="record.sequencingPlatform">{{ '二代：' + record.sequencingPlatform }}</span>
          <span v-if="record.thirdSequencingPlatform">{{ '三代：' + record.thirdSequencingPlatform }}</span>
        </div>
        <div v-else class="status-tag-container">{{'NA'}}</div>
      </div>
      <div slot="analyzeRequirements" slot-scope="{text,record,index}">
        <div v-if="text" class="status-tag-container">{{text}}</div>
        <div v-else class="status-tag-container">{{'NA'}}</div>
      </div>
    </w-table>
  </div>
</template>

<script>

import {project} from "@/utils/data/tableCol/project/project";
import ExFoldTable from "@/components/ExFoldTable.vue";
import {getProjectList, getProjectStatus} from "@/api/dilivery/project";
import _ from "lodash";
import { record } from "@/utils/data/tableCol/record/record";

export default {
  name: "ProjectInfoDialog",
  components: {ExFoldTable},
  props: {
    title: {
      default: '项目'
    },
    showDialog: {
      default: true
    },
    tableData:{
      default:()=>([])
    },
    id: {
      default:''
    },
    terminateFlag:{
      default:false
    },
    isShowRowSelection:{
      default:false
    }
  },
  data(){
    return{
      data:[],
      table:[],
      time:[
        {name:'二代',time:'NGS'},
        {name:'三代',time:'PACBIO'},
        {name:'HIC',time:'HIC'},
        {name:'ONT',time:'ONT'}
      ],
      TypeOption: [
        {label: 'NGS', name: '二代测序'},
        {label: 'AMPLICON', name: '扩增子测序'},
        {label: 'TGG', name: '三代测序'},
        {label: 'METAPRO', name: '蛋白代谢组测序'},
        {label: '硬盘购买', name: '硬盘购买'},
        { label: 'IGUT', name: 'IGUT' },
        {label: 'PCR', name: '其他'}
      ],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      selectable:[],
      tableDataCopy:[]
    }
  },
  computed: {
    columns() {
      if (this.id) {
        return project([] || []).filter(item => !['projectNewAmount'].includes(item.key)) 
      }
      if (this.terminateFlag) {
        return project([] || []).filter(item => !['collectingFlag', 'qualityFlag', 'sampleNum'].includes(item.key))
      }
      return project([] || []).filter(item => !['collectingFlag', 'qualityFlag', 'sampleNum', 'projectNewAmount'].includes(item.key))
    }
  },
  watch:{
    tableData: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.getProjectData()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getProjectData()
  },
  methods: {
    rowSelection(selectedRows) {
      this.selectable = [...selectedRows]
      this.$emit('selectable', this.selectable)
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData() {
      this.page.total = this.table.length
      // 计算当前页的起始索引
      const startIndex = (this.page.currentNum - 1) * this.page.pageSize;
      // 返回当前页的数据
      this.data = this.table.slice(startIndex, startIndex + this.page.pageSize);
    },
    mergeArraysById(arr1, arr2) {
      const mergedMap = new Map();
      // 将数组1和数组2合并到Map中
      [...arr1, ...arr2].forEach(item => {
        if (mergedMap.has(Number(item.projectMainTypeId))) {
          // 如果已存在相同id的对象，合并键值
          const existingItem = mergedMap.get(Number(item.projectMainTypeId));
          mergedMap.set(Number(item.projectMainTypeId), { ...existingItem, ...item });
        } else {
          // 如果不存在，直接添加到Map中
          mergedMap.set(Number(item.projectMainTypeId), item);
        }
      });
      // 将Map转换为数组
      return Array.from(mergedMap.values());
    },
    async getProjectData() {
      try {
        this.tableDataCopy = this.tableData
        if (this.id) {
          const response = await getProjectStatus(this.id)
          if(response.code === 200) {
            this.tableDataCopy = this.mergeArraysById(this.tableDataCopy.filter(item => item.projectMainTypeId), response.data.filter(item => item.projectMainTypeId))
            this.tableDataCopy = _.unionBy(this.tableDataCopy, this.tableData, 'projectType')
          }
        }
        let data = {
          "query#id.IN":this.tableDataCopy.filter(item => item.projectMainTypeId).map(item => item.projectMainTypeId).join(',')
        }
        const response = await getProjectList(data)
        if(response.code === 200){
          this.table = this.tableDataCopy.map(item => {
            const project = response.data.find(it => Number(it.id) === Number(item.projectMainTypeId))
            return {
              ...item,
              projectClassification:project?project.model:item.projectClassification,
              projectType:project?project.name:item.projectType,
              dataAmountUnit: (project?.attribute?.dataAmountUnit) ? project.attribute.dataAmountUnit : ''
            }
          })
          this.getData()
        }
      }catch (error) {
        console.log(error);
      }
    },
    //判断某实验过程结算金额相较原金额是否变动（审核展示高亮）
    isExperimentAmountChanged(record, settledItem) {
      const original = (record.experimentalProcessItems || []).find(it => it.experimentName === settledItem.experimentName)
      if (!original) return false
      return Number(original.experimentAmount) !== Number(settledItem.experimentAmount)
    },
    //判断项目最终结算金额相较项目原金额是否变动（审核展示高亮）
    isProjectAmountChanged(record) {
      const settled = Number(record.projectNewAmount)
      const original = Number(record.projectAmount)
      if (isNaN(settled) || isNaN(original)) return false
      return settled !== original
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
.center {
  display: flex;
  justify-content: center; /* 水平居中 */
  flex-wrap: wrap;
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
.amount-changed {
  color: #f56c6c;
  font-weight: bold;
}
</style>
